import { Link, Title } from '@solidjs/meta';
import { useUrls } from 'Shared/UrlProvider';
import { Dynamic, For, isServer } from 'solid-js/web';
import {OpenSans} from 'Shared/backend/OpenSans';


export function PageMeta(P)
{
	const urls = useUrls();

	return (<>
		<Title>{!isServer && window.useVite ? '🎸DEV ' : ''} Venue Online Services (VOS)</Title>

		<OpenSans />

		<Link rel='stylesheet' href={urls.buildUrl('resources/fontawesome/css/all.min.css')} />
		<Link rel='stylesheet' href={urls.buildUrl('resources/flatpickr.min.css')} />
		<Link rel='stylesheet' href={urls.buildUrl('resources/backend.css')} />

		{/* NOTE could put this on the relevant preview pages instead */}
		<For each={P.settings.fontIncludes()}>{component =>
			<Dynamic component={component} />
		}</For>
	</>);
}


